import { render, staticRenderFns } from "./CustomerAdmin.vue?vue&type=template&id=8388bfd4&scoped=true"
import script from "./CustomerAdmin.vue?vue&type=script&lang=js"
export * from "./CustomerAdmin.vue?vue&type=script&lang=js"
import style0 from "./CustomerAdmin.vue?vue&type=style&index=0&id=8388bfd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8388bfd4",
  null
  
)

export default component.exports